<template>
    <div class="header">
        <div class="header-left">
            <!-- <div class="collapse"
           v-show="showCollapse"
           @click="handleChangeCollapse">
        <i v-show="isCollapse"
           class="el-icon-s-unfold"></i>
        <i v-show="!isCollapse"
           class="el-icon-s-fold"></i>
      </div> -->
            <el-carousel
                style="width: 400px"
                height="40px"
                direction="vertical"
                :autoplay="true"
            >
                <el-carousel-item v-for="item in weatherList" :key="item">
                    <div class="weatherContent">
                        {{ item }}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="header-right">
            <div class="instructions">
                <i class="el-icon-question"></i>
                操作指南
            </div>
            <el-dropdown>
                <div class="menu-list-wrap">
                    <!-- @click="noticeTips"> -->
                    <el-badge
                        :value="
                            Number(this.message_num) + Number(this.waiting_num)
                        "
                        class="item"
                    >
                        <i class="iconfont icon-alarm"></i>
                    </el-badge>

                    <el-dropdown-menu slot="dropdown">
                        <el-tabs
                            v-model="activeName"
                            @tab-click="handleClick"
                            stretch="true"
                            type="border-card"
                        >
                            <el-tab-pane
                                :label="`消息(${this.message_num})`"
                                name="0"
                                class="alarmDrop"
                            >
                                <el-scrollbar
                                    style="height: 100%"
                                    v-if="messageList"
                                >
                                    <div
                                        class="msgCont"
                                        :key="index"
                                        v-for="(item, index) in messageList"
                                    >
                                        <div class="leftCont">
                                            <div style="margin-top: 2px">
                                                {{ item.message | ellipsis30 }}
                                            </div>
                                            <div style="margin-top: 4px">
                                                {{ item.create_at }}
                                            </div>
                                        </div>
                                        <div class="rightCont">
                                            <el-button
                                                type="primary"
                                                plain
                                                size="mini"
                                                @click="msgClick(item)"
                                            >
                                                标记已读
                                            </el-button>
                                        </div>
                                    </div>
                                </el-scrollbar>
                                <div class="defaultMsg" v-else>
                                    没有新的消息
                                </div>
                                <div class="bottomCont" @click="more(0)">
                                    查看更多
                                </div>
                            </el-tab-pane>
                            <el-tab-pane
                                :label="`待办(${this.waiting_num})`"
                                name="1"
                                class="alarmDrop"
                            >
                                <el-scrollbar
                                    style="height: 100%"
                                    v-if="waitingList"
                                >
                                    <div
                                        class="msgCont"
                                        :key="index"
                                        v-for="(item, index) in waitingList"
                                    >
                                        <div class="leftCont">
                                            <div style="margin-top: 2px">
                                                {{ item.message | ellipsis30 }}
                                            </div>
                                            <div style="margin-top: 4px">
                                                {{ item.create_at }}
                                            </div>
                                        </div>
                                        <div class="rightCont">
                                            <el-button
                                                type="primary"
                                                plain
                                                size="mini"
                                                @click="dispose(item)"
                                            >
                                                处理
                                            </el-button>
                                        </div>
                                    </div>
                                </el-scrollbar>
                                <div class="defaultMsg" v-else>
                                    没有新的通知
                                </div>
                                <div class="bottomCont" @click="backlog">
                                    查看更多
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-dropdown-menu>
                    <!-- <div @click="changeSystem(item)"
             v-for="item in userInfo.sys_codes"
             :key="item.sys_code"
             :class="['menu-list-item',{'active-system':activeSys == item.sys_code}]">{{item.sys_code_name}}</div> -->
                </div>
            </el-dropdown>
            <el-dropdown @command="handleCommand">
                <div class="userinfo">
                    <!-- {{userInfo.user_name}}&nbsp;&nbsp;|&nbsp;&nbsp;{{userInfo.user_type_name}} -->
                    <div class="headImgContent">
                        <!-- <img :src="avatar" alt="头像" /> -->
                        <el-avatar
                            size="small"
                            :src="userInfo.avatar || avatar"
                        ></el-avatar>
                    </div>
                    <div class="userName">
                        {{ userInfo.name }}
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="setting"
                            ><i class="iconfont icon-geren"></i
                            >个人设置</el-dropdown-item
                        >
                        <!-- <el-dropdown-item command="changePwd"
                            ><i class="iconfont icon-change_password"></i
                            >修改密码</el-dropdown-item
                        > -->
                        <el-dropdown-item divided command="logout"
                            ><i class="iconfont icon-tuichu"></i
                            >退出登录</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </div>
            </el-dropdown>
        </div>
        <el-dialog
            class="password"
            :visible.sync="passwordVisible"
            :close-on-click-modal="false"
            append-to-body
            @closed="closeDialog"
            width="400px"
            title="修改密码"
            :loading="loading"
            @opened="
                () => {
                    this.$refs['passwordForm'].$el[0].focus();
                }
            "
        >
            <el-form
                :model="passwordForm"
                ref="passwordForm"
                label-width="100px"
                class="formCont"
            >
                <el-form-item
                    prop="current_password"
                    :rules="[
                        { required: true, message: '请输入当前密码' },
                        { pattern: /^.{6,20}$/, message: '密码长度6-20位' },
                    ]"
                    label="当前密码"
                >
                    <el-input
                        placeholder="请输入当前密码"
                        type="password"
                        maxlength="20"
                        size="mini"
                        v-model="passwordForm.current_password"
                        @input="checkCanSavePassword()"
                        autofocus="true"
                        show-password
                    >
                    </el-input>
                </el-form-item>
                <el-form-item
                    prop="password"
                    :rules="[
                        { required: true, message: '请输入新密码' },
                        { pattern: /^.{6,20}$/, message: '密码长度6-20位' },
                    ]"
                    label="新密码"
                >
                    <el-input
                        placeholder="请输入新密码"
                        type="password"
                        maxlength="20"
                        size="mini"
                        v-model="passwordForm.password"
                        @input="checkCanSavePassword()"
                        show-password
                    >
                    </el-input>
                </el-form-item>
                <el-form-item
                    prop="passwordAgain"
                    label="确认密码"
                    :rules="[
                        { required: true, message: '请再次输入新密码' },
                        { pattern: /^.{6,20}$/, message: '密码长度6-20位' },
                    ]"
                >
                    <el-input
                        placeholder="请输入再次新密码"
                        type="password"
                        maxlength="20"
                        size="mini"
                        v-model="passwordForm.passwordAgain"
                        @input="checkCanSavePassword()"
                        show-password
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passwordVisible = false" size="mini"
                    >取 消</el-button
                >
                <el-button
                    :disabled="Boolean(!canSavePassword)"
                    type="primary"
                    @click="changePwd"
                    size="mini"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            class="more"
            :visible.sync="moreVisible"
            :close-on-click-modal="false"
            @closed="closeMoreDialog"
            width="1000px"
            title="消息列表"
            :loading="moreloading"
        >
            <div class="moreCont">
                <el-tabs
                    v-model="activeListName"
                    @tab-click="listHandleClick"
                    stretch="true"
                    type="card"
                >
                    <el-tab-pane label="未读消息" name="0" class="msgTab">
                        <div class="table">
                            <el-table
                                border
                                :data="tableData"
                                v-loading="tableloading"
                                highlight-current-row
                            >
                                <el-table-column
                                    label="类型"
                                    property="event"
                                    align="center"
                                    width="120"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="消息内容"
                                    property="message"
                                    align="left"
                                ></el-table-column>
                                <el-table-column
                                    label="通知时间"
                                    property="create_at"
                                    align="center"
                                    width="200"
                                ></el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <div class="color-blue">
                                            <el-button
                                                type="text"
                                                size="small"
                                                class="color-blue"
                                                @click="readed(scope.row)"
                                                >标记为已读</el-button
                                            >
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <pagination
                                :total="msgTotal"
                                :page.sync="msgPage"
                                :perPage.sync="msgPerPage"
                            ></pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="历史消息" name="1" class="msgTab">
                        <el-table
                            border
                            :data="tableData"
                            v-loading="tableloading"
                            highlight-current-row
                        >
                            <el-table-column
                                label="类型"
                                property="event"
                                align="center"
                                width="120"
                            >
                            </el-table-column>
                            <el-table-column
                                label="消息内容"
                                property="message"
                                align="left"
                            ></el-table-column>
                            <el-table-column
                                label="通知时间"
                                property="create_at"
                                align="center"
                                width="200"
                            ></el-table-column>
                        </el-table>
                        <pagination
                            :total="readedTotal"
                            :page.sync="readedPage"
                            :perPage.sync="readedPerPage"
                        ></pagination>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
        <el-dialog
            class="more"
            :visible.sync="backlogVisible"
            :close-on-click-modal="false"
            @closed="backlogCloseDialog"
            width="1000px"
            title="待办列表"
            :loading="backlogLoading"
        >
            <div class="moreCont">
                <div class="table">
                    <el-table
                        border
                        :data="backlogtableData"
                        highlight-current-row
                    >
                        <el-table-column
                            label="类型"
                            property="event"
                            align="center"
                            width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            label="待办内容"
                            property="message"
                            align="left"
                        ></el-table-column>
                        <el-table-column
                            label="通知时间"
                            property="create_at"
                            align="center"
                            width="200"
                        ></el-table-column>
                        <el-table-column
                            label="操作"
                            align="center"
                            width="200"
                        >
                            <template slot-scope="scope">
                                <div class="color-blue">
                                    <el-button
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        @click="dispose(scope.row)"
                                        >处理</el-button
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination
                        :total="backlogTotal"
                        :page.sync="backlogPage"
                        :perPage.sync="backlogPerPage"
                    ></pagination>
                </div>
            </div>
        </el-dialog>
        <headerDetail
            :rela_code.sync="rela_code"
            :detailVisible.sync="detailVisible"
        ></headerDetail>
        <setting :settingVisible.sync="settingVisible"></setting>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import pagination from "@/comon/components/pagination";
import headerDetail from "./header/header_detail";
import setting from "./header/setting";
export default {
    data() {
        return {
            isCollapse: false,
            activeSys: "",
            userName: "",

            messageList: [],
            waitingList: [],
            message_num: 0,
            waiting_num: 0,
            activeName: "0",
            weatherMsg: "",
            weatherList: [],

            passwordVisible: false,
            passwordForm: {
                password: "",
                passwordAgain: "",
            },
            loading: false,

            moreVisible: false,
            moreLoading: false,
            tableData: [],
            activeListName: "0",
            backlogVisible: false,
            backlogLoading: false,
            backlogtableData: [],

            msgPage: "1",
            msgPerPage: "10",
            msgTotal: "",

            readedPage: "1",
            readedPerPage: "10",
            readedTotal: "",

            backlogTotal: "",
            backlogPage: "1",
            backlogPerPage: "10",

            detailVisible: false,
            rela_code: "",

            timer: null, // 定时器
            settingVisible: false,
            canSavePassword: false,
        };
    },
    components: {
        pagination: pagination,
        headerDetail: headerDetail,
        setting: setting,
    },
    props: {
        showCollapse: {
            type: Boolean,
            default: true,
        },
    },
    created() {
        // this.noticeTips()
        this.weather();
        // this.timer = setInterval(() => {
        //   this.noticeTips()
        // }, 5000)
    },
    watch: {
        backlogPerPage: {
            handler(newValue) {
                this.backlogPerPage = newValue;
                this.backlog();
            },
            deep: true,
            immediate: false,
        },
        backlogPage: {
            handler(newValue) {
                this.backlogPage = newValue;
                this.backlog();
            },
            deep: true,
            immediate: false,
        },
        readedPerPage: {
            handler(newValue) {
                this.readedPerPage = newValue;
                this.more(1);
            },
            deep: true,
            immediate: false,
        },
        readedPage: {
            handler(newValue) {
                this.readedPage = newValue;
                this.more(1);
            },
            deep: true,
            immediate: false,
        },
        msgPerPage: {
            handler(newValue) {
                this.msgPerPage = newValue;
                this.more();
            },
            deep: true,
            immediate: false,
        },
        msgPage: {
            handler(newValue) {
                this.msgPage = newValue;
                this.more();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        userInfo() {
            //   let activeSys = localStorage.getItem("activeSys");
            //   if (activeSys) {
            //     this.activeSys = activeSys;
            //   } else {
            //     this.activeSys = this.$store.state.login.userInfo.sys_codes[0].sys_code;
            //     localStorage.setItem("activeSys", this.activeSys);
            //   }
            return this.$store.state.login.userInfo;
        },
        avatar() {
            return this.$store.state.login.avatar;
        },
        isCollapse() {
            return this.$store.state.index.isCollapse;
        },
        // badgeNum () {
        //   //   return this.alarmList[0].list.length + this.alarmList[1].list.length
        //   return Number(this.message_num) + Number(this.waiting_num)
        // },
    },
    methods: {
        weather() {
            api.weather({}, "get").then((res) => {
                if (res) {
                    this.weatherMsg = res.data;
                    this.weatherList = [];
                    let tempList = this.weatherMsg.split("℃，");
                    tempList[0] = tempList[0] + "℃";
                    tempList.map((item) => {
                        item && this.weatherList.push(item);
                    });
                }
            });
        },
        msgClick(item) {
            oaApi.noticeRead({ id: item.id }, "get").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success("查看成功");
                        // this.noticeTips()
                    }
                }
            });
        },
        // 消息通知列表请求
        noticeTips() {
            oaApi.noticeTips({}, "post").then((res) => {
                if (res) {
                    this.messageList = res.data.message;
                    this.waitingList = res.data.waiting;
                    this.message_num = res.ext.message_num;
                    this.waiting_num = res.ext.waiting_num;
                }
            });
        },
        /**
         * 切换系统
         */
        // changeSystem (sysObject) {
        //   this.activeSys = sysObject.sys_code;
        //   localStorage.setItem("activeSys", this.activeSys);
        //   localStorage.removeItem("tabList");
        //   localStorage.removeItem("activeTab");
        //   this.$store.commit("IS_CHANGE_SYSTEM", true);
        //   this.$store.dispatch("getMenuListByRoles", this.activeSys);
        // },
        handleCommand(command) {
            if (command == "logout") {
                this.logout();
            } else if (command == "changePwd") {
                this.passwordVisible = true;
            } else if (command == "setting") {
                this.settingVisible = true;
            }
        },
        checkCanSavePassword() {
            this.canSavePassword = true;
            const el = this.$refs["passwordForm"].$el;
            for (let i = 0; i < el.length; i++) {
                const { value } = el[i];
                if (value === "") {
                    this.canSavePassword = false;
                    return;
                }
            }
        },
        /**
         * 修改密码提交
         */
        changePwd() {
            this.$refs["passwordForm"].validate((valid) => {
                if (valid) {
                    if (
                        this.passwordForm.password ==
                        this.passwordForm.passwordAgain
                    ) {
                        oaApi
                            .changePwd(
                                {
                                    currentpassword:
                                        this.passwordForm.current_password,
                                    newpassword: this.passwordForm.password,
                                },
                                "post"
                            )
                            .then((res) => {
                                if (res) {
                                    this.passwordVisible = false;
                                    this.$message.success(
                                        "密码修改成功，请重新登录"
                                    );
                                    window.localStorage.clear();
                                    window.localStorage.clear();
                                    setTimeout(() => {
                                        this.$router.push({
                                            path: "/login",
                                        });
                                    }, 1500);
                                }
                            });
                    } else {
                        this.$message.error("新密码两次输入的不一致");
                        this.passwordForm.password = "";
                        this.passwordForm.passwordAgain = "";
                        this.$refs["passwordForm"].$el[1].focus();
                    }
                }
            });
        },
        /**
         * 修改密码弹窗 关闭事件
         */
        closeDialog() {
            this.$refs["passwordForm"].resetFields();
            this.$refs["passwordForm"].clearValidate();
            this.passwordForm = {
                password: "",
                passwordAgain: "",
            };
        },
        /**
         * 退出
         */
        logout() {
            this.$confirm("确定退出此系统吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() =>
                    api.logout({}).then((res) => {
                        if (res) {
                            this.$message.success("退出成功");
                            localStorage.clear();
                            location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&_f=1`;
                            // this.$store.commit("INDEX_COLLAPSE", false);
                        }
                    })
                )
                .catch((e) => {
                    // console.log(e);
                    this.$message.info("已取消退出操作");
                    location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}&_f=1`;
                    // this.$router.replace("/login");
                });
        },
        /**
         * 收起还是展开
         */
        handleChangeCollapse() {
            this.isCollapse = !this.isCollapse;
            this.$store.commit("INDEX_COLLAPSE", this.isCollapse);
        },
        /**
         * 获取消息list
         */
        more(status) {
            this.moreLoading = true;
            oaApi
                .notice(
                    {
                        type: this.activeName,
                        status: status ? status : "",
                        "per-page": status
                            ? this.readedPerPage
                            : this.msgPerPage,
                        page: status ? this.readedPage : this.msgPage,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.moreVisible = true;
                        if (status) {
                            this.readedTotal = res.total;
                        } else {
                            this.msgTotal = res.total;
                        }
                        this.tableData = res.data;
                        this.moreLoading = false;
                    }
                });
        },
        /**
         * 获取待办List
         */
        backlog() {
            this.backlogLoading = true;
            oaApi
                .notice(
                    {
                        type: this.activeName,
                        "per-page": this.backlogPerPage,
                        page: this.backlogPage,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.backlogVisible = true;
                        this.backlogTotal = res.total;
                        this.backlogtableData = res.data;
                        this.backlogLoading = false;
                    }
                });
        },
        /**
         * 关闭消息dialog
         */
        closeMoreDialog() {
            this.tableData = [];
            this.activeListName = "0";
            this.msgPage = "1";
            this.msgPerPage = "10";
            this.msgTotal = "";
        },
        /**
         * 关闭待办dialog
         */
        backlogCloseDialog() {
            this.backlogtableData = [];
            this.backlogTotal = "";
            this.backlogPage = "1";
            this.backlogPerPage = "10";
        },
        /**
         * 列表内 tab切换
         */
        listHandleClick() {
            this.more(this.activeListName);
        },
        /**
         * 列表内标记为已读
         */
        readed(row) {
            oaApi.noticeRead({ id: row.id }, "get").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success("查看成功");
                        // this.noticeTips()
                        this.more();
                    }
                }
            });
        },
        /**
         * 列表内处理动作
         */
        dispose(row) {
            this.rela_code = row.rela_code;
            this.backlogVisible = false;
            this.detailVisible = true;
        },
        // timer () {
        //   let that = this
        //   window.setInterval(() => {
        //     setTimeout(that.noticeTips, 0)
        //   }, 3000)
        // },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
};
</script>
<style lang="scss">
.header {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 39px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 3px;
    box-shadow: 0 2px 4px 0 #c0c4cc;
    .header-left {
        display: inline-flex;
        align-items: center;
        // justify-content: center;
        color: #333;
        font-size: 20px;
        padding-left: 10px;
        .logo-text {
            margin-left: 10px;
        }
        .weatherContent {
            width: 400px;
            height: 40px;
            font-size: 12px;
            display: flex;
            align-items: center;
            text-align: left;
            text-indent: 12px;
            i {
                padding: 0 12px;
            }
        }
    }
    .logo-wrap {
        .logo {
            color: #333;
        }
        .collapse {
            cursor: pointer;
        }
        .logo-img {
            width: 126px;
            margin-right: 10px;
            margin-left: 20px;
        }
        height: 70px;
        // width: 210px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        i {
            font-size: 20px;
            color: #333;
            padding-left: 20px;
        }
    }
    .menu-list-wrap {
        display: inline-flex;
        cursor: pointer;
        // margin-left: 30px;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        &:hover {
            background: rgba(60, 60, 60, 0.1);
        }
        i {
            font-size: 18px;
        }
        .menu-list-item {
            margin-right: 40px;
            opacity: 1;
            position: relative;
            color: #212121;
            cursor: pointer;
            &::after {
                position: absolute;
                content: "";
                top: 170%;
                left: 50%;
                margin-left: -30%;
                width: 60%;
                height: 3px;
                background: #17579f;
                transform: scaleX(0);
                transform-origin: right;
                transition: transform 0.5s;
            }

            &:hover {
                opacity: 1;
                color: #17579f;
            }

            &:hover::after {
                transform: scaleX(1);
                transform-origin: left;
            }
        }
        .active-system {
            opacity: 1;
            color: #17579f;
            &::after {
                position: absolute;
                content: "";
                top: 165%;
                left: 50%;
                margin-left: -30%;
                width: 60%;
                height: 3px;
                border-radius: 3px;
                background: #17579f;
                transform: scaleX(1);
                transform-origin: left;
                transition: transform 0.5s;
            }
        }
    }
    .logout {
        padding-right: 20px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
    }
    .header-right {
        color: #333;
        display: inline-flex;
        align-items: center;
        height: 40px;
        .instructions {
            cursor: pointer;
            user-select: none;
            margin-right: 5px;
            display: flex;
            align-items: center;
            font-size: 12px;
            i {
                font-size: 16px;
                margin-right: 3px;
            }
        }
    }
    .userinfo {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .headImgContent {
            height: 30px;
            width: 30px;
            // border-radius: 15px;
            // overflow: hidden;
            margin: 5px 15px;
            img {
                width: 100%;
            }
        }
        .userName {
            padding-right: 20px;
            font-size: 12px;
        }
        &:hover {
            background: rgba(60, 60, 60, 0.1);
        }
    }
}
.el-tabs__content {
    width: 330px;
    padding: 0 !important;
}
.alarmDrop {
    height: 276px;
    padding: 0;
    position: relative;
    .defaultMsg {
        width: 100%;
        display: inline-flex;
        height: 100%;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: rgb(60, 60, 60);
    }
    .el-scrollbar__view {
        margin-bottom: 36px;
    }
    .msgCont {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 15px !important;
        border-top: 1px #ddd solid;
        .leftCont {
            div {
                // height: 18px;
                width: 90%;
                line-height: 14px;
                font-size: 12px;
                display: flex;
                flex-direction: column-reverse;
                justify-content: space-around;
            }
        }
        .rightCont {
            color: #333;
            display: inline-flex;
        }
    }
    .bottomCont {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 36px;
        height: 36px;
        font-size: 12px;
        text-align: center;
        background: #fff;
        color: #000;
        border-top: 1px #ddd solid;
        cursor: pointer;
        &:hover {
            color: #333;
        }
    }
}
.el-dropdown-menu {
    padding: 0;
    .el-dropdown-menu__item {
        font-size: 12px;
    }
}
.el-form-item__error {
    padding-top: 2px;
}
.more {
    .moreCont {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        .el-tabs__header {
            margin: 0 !important;
            width: 200px;
        }
    }
    // .el-tabs__item {
    //     width: 200px;
    // }
    .el-tabs__content {
        width: 100%;
    }
    .el-table th {
        // background: #fff !important;
    }
    .el-table--border th,
    .el-table--border td {
        // border: 0;
    }
    .el-dialog__body {
        // padding: 0px;
    }
}
.el-dialog__wrapper.password {
    .el-dialog {
        padding-bottom: 30px;
        .el-form-item__content {
            padding-right: 20px;
        }
    }
}
</style>
